var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('router-view',{attrs:{"name":"header"}})],1),_c('section',[_c('router-view',{staticClass:"p-2",attrs:{"name":"body"}})],1),_c('footer',[_c('router-view',{attrs:{"name":"footer"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }